export default {
  token: null,
  refreshToken: null,
  id: null,
  userData: {},
  userApiKeyData: {},
  fiatList: JSON.parse(process.env.VUE_APP_FIAT_LIST),
  requestsAttentionModal: false,
}
